import React, { createContext, useState } from "react";

interface DetailsByPageableActionContextType {  
  backendFormErrors: any;
  setBackendFormErrors: (backendFormErrors: any) => void;    
  element: any;
  setElement: (element: any) => void;
  schema: any;
  setSchema: (schema: any) => void;
  schemaUI: any;
  setSchemaUI: (schema: any) => void;
  selectedLang: string;
  setSelectedLang: (selectedLang: string) => void;
}

export const DetailsByPageableActionContext = createContext<DetailsByPageableActionContextType>({
  backendFormErrors: {},
  setBackendFormErrors: () => {},
  element: null,
  setElement: () => {},
  schema: null,
  setSchema: () => {},
  schemaUI: null,
  setSchemaUI: () => {},
  selectedLang: "",
  setSelectedLang: () => {},
});

interface DetailsByPageableActionProviderProps {
  children: React.ReactNode;
}

export const DetailsByPageableActionProvider: React.FC<DetailsByPageableActionProviderProps> = ({
  children,
}) => {  
  const [backendFormErrors, setBackendFormErrors] = useState(null);
  const [element, setElement] = useState<any>(null);  
  const [schema, setSchema] = useState<any>(null);
  const [schemaUI, setSchemaUI] = useState<any>(null);
  const [selectedLang, setSelectedLang] = useState<string>("");

  const value = {    
    backendFormErrors,
    setBackendFormErrors,
    element,
    setElement,
    schema,
    setSchema,
    schemaUI,
    setSchemaUI,
    selectedLang,
    setSelectedLang,
  };
  return (
    <DetailsByPageableActionContext.Provider value={value}>      
      {children}
    </DetailsByPageableActionContext.Provider>
  );
};
